import api from '../../../../api/api';
import { reviewsApi } from '../../../../api/reviews';

export const ownAlbumReview = (album, reviews, userId) => {
  if (userId == null) return null;
  return (
    album.myReview ?? reviews.find((review) => String(review.user?.id) === String(userId)) ?? null
  );
};

// Build58 uses the persisted album ID for edits, never the external catalogue ID.
export async function saveAlbumReview(album, review, { rating, selected, content }, mode) {
  if (!selected || !Number.isFinite(rating) || rating < 0 || rating > 5 || (rating * 2) % 1)
    throw new Error('Invalid rating');
  const text = mode === 'rating' ? (review?.content ?? '') : content.trim();
  if ((mode === 'review' && !text) || text.length > 10000) throw new Error('Invalid review');
  const id = Number(album.id);
  if (review?.id) {
    if (!(id > 0)) throw new Error('Missing album ID');
    return reviewsApi.updateReview(id, review.id, text, rating);
  }
  if (id > 0) return reviewsApi.postReview(id, text, rating);
  const source = String(album.albumSource ?? '').toLowerCase();
  if (!album.sourceId || !['apple_music', 'spotify', 'postpop'].includes(source))
    throw new Error('Missing album source');
  const query = new URLSearchParams({ id: album.sourceId, type: source });
  const response = await api.postAuth(`/albums/reviews?${query}`, { content: text, rating });
  return response.data;
}

export function deleteAlbumReview(album, review) {
  if (!(Number(album.id) > 0) || !review?.id) throw new Error('Missing review ID');
  return reviewsApi.deleteReview(album.id, review.id);
}

export function ratingAtPosition(x, width) {
  const slot = width / 5;
  const clamped = Math.max(0, Math.min(width - 0.01, x));
  if (clamped <= slot * 0.16) return 0;
  return Math.min(5, Math.floor(clamped / slot) + (clamped % slot < slot / 2 ? 0.5 : 1));
}
